import { render, staticRenderFns } from "./LinkIntegracao.vue?vue&type=template&id=4b6df434"
import script from "./LinkIntegracao.vue?vue&type=script&lang=js"
export * from "./LinkIntegracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports